module.exports = __webpack_public_path__ + "static/media/flower.6144cb1d.jpg";